import { format, parseISO, startOfDay } from "date-fns";

/**
 * Local-TZ date-only ключ (`YYYY-MM-DD`).
 *
 * Везде, где нам нужно сериализовать «день» как строку (URL/range-params для
 * `/api/units/:code/load`, ключи overrides календаря, кэш Query), используем
 * локальную TZ браузера, а не `toISOString()`. В зонах с положительным UTC
 * offset (MSK +03:00) `new Date(2026, 0, 1).toISOString().slice(0,10)` даёт
 * `"2025-12-31"` — off-by-one. Когда появится user-tz preference (Phase 3) —
 * правка будет одного модуля.
 */
export function toDateKey(d: Date): string {
  return format(d, "yyyy-MM-dd");
}

export function todayKey(): string {
  return toDateKey(new Date());
}

/**
 * Inverse of `toDateKey`: `"YYYY-MM-DD"` → `Date` в локальной полуночи.
 * `parseISO` сам распознаёт date-only форму как локальное время; `startOfDay`
 * лишний раз нормализует к 00:00 (на случай если на вход придёт «YYYY-MM-DDTHH»).
 */
export function fromDateKey(key: string): Date {
  return startOfDay(parseISO(key));
}
